import { Link } from "react-router-dom";
import { Shield, Mail, Phone } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export default function Footer() {
  const { content } = useContent();
  return (
    <footer className="bg-forest-900 text-bone/80 mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2 max-w-sm">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="grid place-items-center h-9 w-9 rounded-xl bg-terracotta-400 text-white">
              <Shield className="h-5 w-5" strokeWidth={1.5} />
            </span>
            <span className="font-serif text-lg text-bone font-semibold">Patria ER CoE</span>
          </div>
          <p className="text-sm leading-relaxed text-bone/70">
            The Employee Relations Center of Excellence is a consistent, impartial resource for workplace
            concerns across all Patria campuses — here for you at any time.
          </p>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.18em] uppercase text-terracotta-300 font-bold mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/report" className="hover:text-bone transition-colors">Share a Concern</Link></li>
            <li><Link to="/track" className="hover:text-bone transition-colors">Track a Concern</Link></li>
            <li><Link to="/resources" className="hover:text-bone transition-colors">Policies & Resources</Link></li>
            <li><Link to="/login" className="hover:text-bone transition-colors">Team Sign In</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.18em] uppercase text-terracotta-300 font-bold mb-4">Contact the CoE</h4>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-terracotta-300" strokeWidth={1.5} /> {content.contact.email}</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-terracotta-300" strokeWidth={1.5} /> {content.contact.phone}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-bone/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-bone/50">
          <span>&copy; {new Date().getFullYear()} Patria Church. All matters handled with confidentiality.</span>
          <span>Non-Harassment &bull; Non-Discrimination &bull; Anti-Retaliation</span>
        </div>
      </div>
    </footer>
  );
}
